const initialState = {
  queue: [],
  currentIndex: -1,
  isPlaying: false,
  lastUpdated: 0,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "PLAY_AUDIO":
      return {
        ...state,
        queue: [action.payload],
        currentIndex: 0,
        isPlaying: true,
        lastUpdated: Date.now(),
      };
    case "PLAY_ALL":
      return {
        ...state,
        queue: action.payload,
        currentIndex: 0,
        isPlaying: true,
        lastUpdated: Date.now(),
      };
    case "QUEUE_ALL":
      const queueWasEmpty = state.queue.length === 0;
      return {
        ...state,
        queue: [...state.queue, ...action.payload],
        currentIndex: state.currentIndex === -1 ? 0 : state.currentIndex,
        isPlaying: true,
        lastUpdated: queueWasEmpty ? Date.now() : state.lastUpdated,
      };
    case "ADD_TO_QUEUE":
      const isQueueEmpty = state.queue.length === 0;
      return {
        ...state,
        queue: [...state.queue, action.payload],
        // If nothing is playing, start the newly added track
        currentIndex: state.currentIndex === -1 ? 0 : state.currentIndex,
        isPlaying: true,
        // Only trigger a force-reload if we're starting a fresh play from empty
        lastUpdated: isQueueEmpty ? Date.now() : state.lastUpdated,
      };
    case "NEXT_TRACK":
      if (state.currentIndex < state.queue.length - 1) {
        return {
          ...state,
          currentIndex: state.currentIndex + 1,
          isPlaying: true,
          lastUpdated: Date.now(),
        };
      }
      return state;
    case "PREVIOUS_TRACK":
      if (state.currentIndex > 0) {
        return {
          ...state,
          currentIndex: state.currentIndex - 1,
          isPlaying: true,
          lastUpdated: Date.now(),
        };
      }
      return state;
    case "REMOVE_FROM_QUEUE":
      const filteredQueue = state.queue.filter((_, i) => i !== action.payload);
      let nextIndex = state.currentIndex;
      let shouldUpdateTimestamp = false;

      if (action.payload < state.currentIndex) {
        nextIndex -= 1;
      } else if (action.payload === state.currentIndex) {
        shouldUpdateTimestamp = true;
        if (filteredQueue.length === 0) {
          return initialState;
        }
        if (nextIndex >= filteredQueue.length) {
          nextIndex = filteredQueue.length - 1;
        }
      }
      return {
        ...state,
        queue: filteredQueue,
        currentIndex: nextIndex,
        lastUpdated: shouldUpdateTimestamp ? Date.now() : state.lastUpdated,
      };
    case "SELECT_QUEUE_TRACK":
      if (action.payload < 0 || action.payload >= state.queue.length) {
        return state;
      }
      return {
        ...state,
        currentIndex: action.payload,
        isPlaying: true,
        lastUpdated: Date.now(),
      };
    case "SET_PLAYING":
      return {
        ...state,
        isPlaying: action.payload,
      };
    case "STOP_AUDIO":
      return initialState;
    default:
      return state;
  }
}
